import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Crown, Bot, Image, TrendingUp } from "lucide-react";
import { useStoredAuth } from "@/hooks/useStoredAuth";
import PremiumLock from "./PremiumLock";

export default function AIToolsSection() {
  const { user, isAuthenticated } = useStoredAuth();
  const hasAccess = isAuthenticated && user?.isPremium;

  const tools = [
    {
      name: "GPT-4 Chat",
      category: "Procesamiento de Lenguaje",
      description: "Modelo de lenguaje avanzado para conversaciones y generación de texto",
      icon: Bot,
      color: "bg-blue-600",
    },
    {
      name: "DALL-E 3",
      category: "Generación de Imágenes",
      description: "Crea imágenes realistas y artísticas desde descripciones de texto",
      icon: Image,
      color: "bg-purple-600",
    },
    {
      name: "AutoML Vision",
      category: "Visión Computacional",
      description: "Entrena modelos de clasificación de imágenes automáticamente",
      icon: TrendingUp,
      color: "bg-emerald-500",
    },
  ];

  return (
    <section id="tools" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-2">Herramientas de IA</h3>
            <p className="text-lg text-gray-600">Las mejores herramientas y modelos de inteligencia artificial</p>
          </div>
          {!hasAccess && (
            <span className="bg-amber-400 text-white px-4 py-2 rounded-full font-semibold flex items-center">
              <Crown className="mr-2 w-4 h-4" />
              Premium
            </span>
          )}
        </div>

        <div className="relative">
          {!hasAccess && (
            <PremiumLock
              title="Contenido Premium"
              description="Actualiza tu cuenta para acceder a todas las herramientas de IA"
            />
          )}

          <div className={`grid md:grid-cols-2 lg:grid-cols-3 gap-6 ${!hasAccess ? 'filter blur-sm' : ''}`}>
            {tools.map((tool, index) => {
              const IconComponent = tool.icon;
              return (
                <Card key={index} className="bg-gray-50 border border-gray-200">
                  <CardContent className="p-6">
                    <div className="flex items-center mb-4">
                      <div className={`w-10 h-10 ${tool.color} rounded-lg flex items-center justify-center mr-3`}>
                        <IconComponent className="text-white" size={20} />
                      </div>
                      <div>
                        <h5 className="font-semibold text-gray-900">{tool.name}</h5>
                        <p className="text-sm text-gray-600">{tool.category}</p>
                      </div>
                    </div>
                    <p className="text-gray-600 text-sm mb-4">{tool.description}</p>
                    <Button className={`w-full ${tool.color} text-white hover:opacity-90`}>
                      Usar Herramienta
                    </Button>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
